import { GroupWrapper } from '@dealstack/frontend/shared/components/fundament/GroupWrapper/GroupWrapper';
import { Flex } from '@mantine/core';
import React, { FunctionComponentElement } from 'react';
import { useController, useFormContext, useWatch } from 'react-hook-form';
import styled from 'styled-components';
import { IGroupWrapperProps } from '@dealstack/frontend/shared/components/fundament/GroupWrapper/GroupWrapper.types';

interface IRadioGroupProps extends IGroupWrapperProps {
	className?: string;
	children?: React.ReactNode;
	name: string;
	disabled?: boolean;
}

interface CloneExpandedProps {
	checked: boolean;
	disabled?: boolean;
	onClick: unknown;
}

const RadioGroup = ({ name, children, label, hint, className, disabled }: IRadioGroupProps) => {
	const methods = useFormContext();
	const controller = useController({
		name,
		control: methods.control,
	});
	useWatch();

	const childrenWithProps = React.Children.map(children, (child) => {
		if (React.isValidElement(child)) {
			const { value, onClick, disabled: childDisabled } = child.props;
			const isDisabled = disabled || childDisabled;
			return React.cloneElement<CloneExpandedProps>(
				child as FunctionComponentElement<CloneExpandedProps>,
				{
					checked: controller.field.value === value,
					disabled: isDisabled,
					onClick: (event: React.MouseEvent<HTMLElement>) => {
						if (isDisabled) {
							return;
						}
						controller.field.onChange(value);
						onClick?.(event);
					},
				}
			);
		}
		return child;
	});

	return (
		<Flex direction="column" className={className}>
			<GroupWrapper label={label} hint={hint}>
				<RadioWrapper>{childrenWithProps}</RadioWrapper>
			</GroupWrapper>
		</Flex>
	);
};

export const RadioWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5em;
	padding-top: 0.5em;
`;
const _RadioGroupExport = styled(RadioGroup)``;

export { _RadioGroupExport as RadioGroup };
